import React, { useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/dist/styles.css";
import Inline from "yet-another-react-lightbox/dist/plugins/inline";
interface Props {
  sources: string[];
  imageHeight?: string;
}
const ImageCarousel: React.FC<Props> = (props) => {
  const { sources } = props;
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);

  const slides = sources.map((src) => ({
    src,
  }));
  return (
    <>
      <Lightbox
        index={index}
        open={open}
        close={() => setOpen(false)}
        slides={slides}
        on={{
          view: ({ index }) => setIndex(index),
          click: () => setOpen(true),
        }}
        styles={{ container: { backgroundColor: "transparent" } }}
        carousel={{
          padding: 0,
          spacing: 0,
          imageFit: "cover",
          imageProps: {
            style: {
              borderRadius: "8px",
            },
          },
        }}
        inline={{
          style: {
            width: "100%",
            maxWidth: "900px",
            margin: "0 auto",
            aspectRatio: "16/9",
          },
        }}
        // @ts-ignore
        plugins={[Inline]}
      />
      <Lightbox
        index={index}
        open={open}
        close={() => setOpen(false)}
        on={{ view: ({ index }) => setIndex(index) }}
        slides={slides}
        animation={{ fade: 0 }}
        controller={{ closeOnPullDown: true, closeOnBackdropClick: true }}
      />
    </>
  );
};

export default ImageCarousel;
